import Vue from 'vue'
import Vuex from 'vuex'
import equipos from './modules/equipos'
import partidos from './modules/partidos'
import personas from './modules/personas'
import planillas from './modules/planillas'
import localization from './modules/localization'
import estadisticas from './modules/estadisticas'
import auth from './modules/auth'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    equipos,
    partidos,
    personas,
    planillas,
    estadisticas,
    localization,
    auth
  },
  strict: debug
})